<template>
  <div ref="container">
    <div class="d-none" ref="placeholder"></div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";

interface Props {
    eventId: string;
    color: string;
}

const props = defineProps<Props>();
const container = ref<HTMLElement | null>(null);
const placeholder = ref<HTMLElement | null>(null);
let setupInterval: number | null = null;
let instance: any = null;

function clearSetupInterval(): void {
    if (setupInterval !== null) {
        clearInterval(setupInterval);
        setupInterval = null;
    }
}

function setup(): void {
    const manager = window.$billetto.manager;
    if (!manager || !container.value || !placeholder.value) {
        return;
    }

    clearSetupInterval();
    instance = manager.register(container.value, "event", {
        identifier: props.eventId,
        color: props.color,
        whitelabel: true,
        locale: "sv",
        theme: "light",
        organization: "billetto.se",
    });
    instance.mount(placeholder.value);
}

onMounted(() => {
    setupInterval = window.setInterval(setup, 100);
});

onBeforeUnmount(() => {
    clearSetupInterval();
    instance?.destroy();
});
</script>
